import { WEDDING } from '#app/config/wedding.ts'
import { cn } from '#app/utils/misc.tsx'

/** The couple's monogram ("K & A") set in the display serif, with an accent ampersand. */
export function Monogram({ className }: { className?: string }) {
	const [a, b] = WEDDING.couple.short.split('&').map(s => s.trim())
	return (
		<span className={cn('font-serif leading-none text-ink', className)}>
			{a} <em className="not-italic text-brown">&amp;</em> {b}
		</span>
	)
}

/** Decorative leaf ornament (replaces the old raster fleuron). */
export function Fleuron({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 120 120"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			className={cn('text-brown', className)}
			aria-hidden="true"
		>
			<path d="M60 112V22" />
			<path d="M60 34c-14-4-24-14-26-26 12 2 22 12 26 26Z" />
			<path d="M60 34c14-4 24-14 26-26-12 2-22 12-26 26Z" />
			<path d="M60 58c-18-4-30-16-32-30 14 2 28 14 32 30Z" />
			<path d="M60 58c18-4 30-16 32-30-14 2-28 14-32 30Z" />
			<path d="M60 84c-20-4-34-18-36-34 16 2 32 16 36 34Z" />
			<path d="M60 84c20-4 34-18 36-34-16 2-32 16-36 34Z" />
			<circle cx="60" cy="16" r="3" />
		</svg>
	)
}
